import { Button, Text } from '@loomhq/lens';
import classnames from 'classnames';
import pluralize from 'pluralize';
import React from 'react';

import WorkspaceLogo from '../../../workspace-logo';

import styles from './styles.module.less';

export const SUGGESTED_LABEL = (
  <span
    className={classnames(
      'text:small weight:bold c:teal radius:large px:small py:xsmall ml:xsmall',
      styles.suggestedLabel
    )}
  >
    Suggested
  </span>
);

function WorkspaceListItem({
  workspace,
  autoJoin,
  isSuggested,
  onRequestClick,
  isMobile,
  isSelected,
  onMobileSelect,
  additionalClass,
}) {
  const memberCount = workspace.counts?.users?.total_active_workspace_users;

  const label = isSuggested && !isMobile ? SUGGESTED_LABEL : null;

  function onClick() {
    onMobileSelect({ id: workspace.id, autoJoin });
  }

  return (
    <div
      className={classnames(
        additionalClass,
        styles.workspaceListItem,
        isMobile && isSelected && styles.selectedRow,
        'flex items:center width:full justify:spaceBetween p:medium'
      )}
      onClick={isMobile ? onClick : null}
      role={isMobile ? 'button' : 'listitem'}
      tabIndex={0}
      aria-label={workspace.name}
      data-cy={autoJoin ? 'autoJoin' : 'requestAccess'}
    >
      <div className="shrink:0">
        <WorkspaceLogo workspace={workspace} size={6} />
      </div>

      <div className="flex flexDirection:column text:left mx:small grow:1 ellipsis">
        <div className="flex">
          <Text fontWeight="bold" size="medium" hasEllipsis>
            {workspace.name}
          </Text>
          {label}
        </div>
        {Boolean(memberCount) && (
          <span className="text:small c:bodyDimmed">
            {memberCount} {pluralize('Member', memberCount)}
          </span>
        )}
      </div>

      {!isMobile && (
        <div className="shrink:0">
          <Button
            onClick={() => onRequestClick(workspace.id)}
            variant="primary"
            id="joinButton"
          >
            {autoJoin ? 'Join' : 'Request access'}
          </Button>
        </div>
      )}
    </div>
  );
}

export default WorkspaceListItem;
